import React from "react";
import { Alert, AlertTitle, Snackbar } from "@mui/material";
import { Success } from "./IconBackground";
import { CheckValue } from "../../Service/service";
import { InfoIcon } from "../Icon";

const AlertUI = ({ alerts, hideAlerts }) => {
  return (
    <React.Fragment>
      {alerts.map((el) => (
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          key={el.id}
          open={true}
          autoHideDuration={el.duration}
          onClose={() => hideAlerts(el.id)}
        >
          <Alert
            severity={el.type}
            iconMapping={{
              success: (
                <Success>
                  <InfoIcon sx={{ color: "#039855" }} />
                </Success>
              ),
            }}
            variant="outlined"
            sx={{
              width: "100%",
              border: "1px solid #F2F4F7",
              background: "#ffffff",
              alignItems: "center",
              minWidth: "200px",
              "& .MuiAlertTitle-root": {
                color: "#101828",
                fontWeight: 600,
                fontSize: "14px",
                lineHeight: "20px",
              },
            }}
            onClose={() => hideAlerts(el.id)}
          >
            <AlertTitle
              sx={{ marginBottom: CheckValue(el.message) ? "inherit" : 0 }}
            >
              {el.title}
            </AlertTitle>
          </Alert>
        </Snackbar>
      ))}
    </React.Fragment>
  );
};

export default AlertUI;
